/**Agrupa todos los resources de la aplicación */
/*
NOTA: Hay que ir registrando aqui los recursos conforme los vayamos ocupando para que queden
todos en un mismo lugar
*/

import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");

//Definiciones inline:


//simples:
export * from "./simple";
export * from "./items/index";


// WEBPACK FOOTER //
// ./app/resources/index.ts